import { render, staticRenderFns } from "./meetingApproval.vue?vue&type=template&id=cb8cfdda&scoped=true&"
import script from "./meetingApproval.vue?vue&type=script&lang=js&"
export * from "./meetingApproval.vue?vue&type=script&lang=js&"
import style0 from "./meetingApproval.vue?vue&type=style&index=0&id=cb8cfdda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8cfdda",
  null
  
)

export default component.exports